var activetriggerTemplate = require('../templates/searchbox-activetrigger.handlebars');

class SearchBox {

    constructor() {
        this.$elm = $('.searchBox');
        this.$trigger = $('.searchBox-trigger');
        this.$header = $('.header');
        this.$input = this.$elm.find('.inputField');
        this.$submit = this.$elm.find('.searchBox-submit');
        this.$form = this.$elm.find('form');
        this.activeClass = 'searchBox--isOpen';
        this.triggerActiveClass = 'is-active';
        this.headerActiveClass = 'header--searchBoxIsOpen';

        this.submitClicked = false;

        if (this.$trigger[0] !== null && typeof this.$trigger[0] !== "undefined") {
            this.triggerHtml = this.$trigger[0].innerHTML;
            this.triggerText = this.$header[0].dataset.closeText;

            this.setEventListeners();
        }
    }

    setEventListeners() {
        this.$trigger
            .on('click', this.onMenuIconClick.bind(this));
        this.$input
            .on('blur', this.onInputBlur.bind(this));
        this.$submit
            .on('click', this.onSubmitClick.bind(this));
    }

    toggle() {
        if (this.$trigger.hasClass(this.triggerActiveClass)) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        this.$trigger.addClass(this.triggerActiveClass);
        this.$elm.addClass(this.activeClass);
        this.$header.addClass(this.headerActiveClass);
        this.$input.focus();

        this.$trigger.html(activetriggerTemplate({
            triggerText: this.triggerText
        }));
    }

    close() {
        this.$trigger.removeClass(this.triggerActiveClass);
        this.$elm.removeClass(this.activeClass);
        this.$header.removeClass(this.headerActiveClass);

        this.$trigger.html(this.triggerHtml);
    }

    onMenuIconClick(event) {
        event.preventDefault();

        this.toggle();
    }

    onInputBlur(event) {
        //timeout to be able to check for submit clicked state
        setTimeout(() => {
            if (!this.submitClicked) {
                this.close();
            }
        }, 200);
    }

    onSubmitClick(event) {
        event.preventDefault();

        this.submitClicked = true;
        this.$form.submit();
    }
}

export default SearchBox;